(function ($) {
    $.fn.konami = function (callback, code) {
        if (code == undefined) code = "68,65,82,76,69,78,69";

        return this.each(function () {
            var kkeys = [];
            $(this).keydown(function (e) {
                var target = $(e.target);
                if (!target.is('input') && !target.is('textarea')) {
                    kkeys.push(e.keyCode);
                    while (kkeys.length > code.split(',').length) {
                        kkeys.shift();
                    }
                    if (kkeys.toString().indexOf(code) >= 0) {
                        // comment out the line below to allow the code to be entered multiple times
                        $(this).unbind('keydown', arguments.callee);
                        callback(e);
                    }
                }
            });
        });
    }

    $(document).ready(function () {
        $(document).konami(function () {
            //alert('Konami Code Activated');
            //$.fancybox({ href: '/assets/gdee/index.html', width: '980px', height: '780px', type: 'iframe' });
            SnhuUtilities.SetCookie('gdee', '1', 1, '/');

            // manually fire the analytics event
            // legacy ga.js method
            //var _gaq = _gaq || [];
            //_gaq.push(['_trackEvent', 'EE', location.href, 'STEM072016']);

            // analytics.js method - universal analytics
            ga('trackerUA91129391.send', {
                hitType: 'event',
                eventCategory: 'EE',
                eventAction: location.href,
                eventLabel: 'STEM072016',
                hitCallback: createFunctionWithTimeout(function() {
                    location.href = '/online-degrees/bachelors/bs-in-game-programming-and-development';
                }, 500)
            });

        });

        function createFunctionWithTimeout(callback, opt_timeout) {
            var called = false;
            function fn() {
                if (!called) {
                    called = true;
                    callback();
                }
            }
            setTimeout(fn, opt_timeout || 1000);
            return fn;
        }

        // pop up the game if redirected from home
        //if (SnhuUtilities.GetParameterByName('kce') == '1') {
            var trigger = SnhuUtilities.GetCookie('gdee');
            if (trigger == '1') {
                SnhuUtilities.ExpireCookie('gdee');
                $.fancybox({
                    href: '/assets/gdee/index.html',
                    width: '980px',
                    height: '780px',
                    type: 'iframe',
                    afterShow: function() {
                        $('.fancybox-inner iframe').attr('tabindex', 1).focus();
                    }
                });
            }
        //}
    });
})(jQuery);

